import Logo from '../utilities/dummy_assets/logo.png';
import Logo1 from '../utilities/dummy_assets/MBF_Logo.png';
import mapITlogo from '../utilities/dummy_assets/svgs/MapIt_Logo.svg';
import tinkerersLogo from '../utilities/dummy_assets/tinkerersLogo_1.png';
import tinkerersLogo1 from '../utilities/dummy_assets/tinkerersLogo.png';
import { Box, Typography } from '@mui/material';

export default function Logos() {
  return (
    <Box
      sx={{
        justifyContent: 'center',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center', // Adjust alignment to center
        p: '16px 24px',
        mt: 'auto', // Push the footer to the bottom
        gap: { xs: '2rem', sm: '1rem' }, // Add consistent spacing between elements
      }}
    >
      <Box sx={{ display: { sm: 'none' } }}>
        <img
          src={Logo}
          alt="MBF Logo"
          style={{ height: '60px', width: '60px' }}
        />
      </Box>
      <Box sx={{ display: { sm: 'none' } }}>
        <img
          src={tinkerersLogo}
          alt="mapIT Logo"
          style={{ height: '60px', width: '60px' }}
        />
      </Box>
      <Box sx={{ display: { xs: 'none', sm: 'inherit' } }}>
        <img
          src={Logo1}
          alt="MBF Logo"
          style={{ height: '60px', width: '150' }}
        />
      </Box>
      <Box sx={{ display: { xs: 'none', sm: 'inherit' } }}>
        <img
          src={tinkerersLogo1}
          alt="mapIT Logo"
          style={{ height: '60px', width: '150px' }}
        />
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: '0.5rem' }}>
        <img
          src={mapITlogo}
          alt="mapIT Logo"
          style={{ height: '60px', width: '135px' }}
        />
      </Box>
    </Box>
  );
}
